
import Vue from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default Vue.extend({
	name: 'MarkOnFileBanner',
	components: {
		FontAwesomeIcon
	},
	props: {
		totalRequestsWithMatches: {
			type: Number,
			required: true
		},
		totalMatchCount: {
			type: Number,
			required: true
		}
	},
	computed: {
		showBanner(): boolean {
			return this.totalRequestsWithMatches > 0;
		},
		bannerMessage(): string {
			const requestCount = this.totalRequestsWithMatches;
			const matchCount = this.totalMatchCount;

			if (requestCount === 1) {
				const documentText = matchCount === 1 ? 'document' : 'documents';
				return (
					`We found ${matchCount} potential matching ${documentText} for 1 document request. ` +
					'Click on the badge to select the correct file to mark on file.'
				);
			} else {
				const documentText = matchCount === 1 ? 'document' : 'documents';
				const requestText = requestCount === 1 ? 'request' : 'requests';
				return (
					`We found ${matchCount} potential matching ${documentText} for ${requestCount} document ${requestText}. ` +
					'Click on the badges to select the correct files to mark on file.'
				);
			}
		}
	}
});
